import * as React from 'react';

function PaginationArrow({ direction = 'right' }) {
  return (
    <svg
      style={{ transform: direction !== 'right' ? 'rotate(180deg)' : 'none' }}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M6 12L10 8L6 4" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default PaginationArrow;
